import { Box, styled } from '@mui/system';
import {
    FOOTER_HEIGHT_DESKTOP,
    HEADER_HEIGHT,
    HT_MAX_WIDTH_CONTENT,
} from '@/lib/constants/hyperTrackerConstants';
import _DownloadIcon from '@/assets/images/icons/download_hypertracker_icon.svg?react';
import _CopyIcon from '@/assets/images/icons/copy_icon.svg?react';

export const CaptureWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    width: '100%',
    top: 42,
    zIndex: 2,
    [theme.breakpoints.down('md')]: {
        top: 80,
    },
}));

export const CaptureBannerContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
    justifyContent: 'center',
    padding: '6px 12px',
    backgroundColor: theme.palette.secondary.main,
    borderBottomRightRadius: '8px',
    borderBottomLeftRadius: '8px',
}));

export const CaptureBorder = styled(Box)(({ theme }) => ({
    border: `2px solid ${theme.palette.secondary.main}`,
    width: `calc(100vw - 60px)`,
    maxWidth: `calc(${HT_MAX_WIDTH_CONTENT} + 32px)`,
    height: `calc(100vh - ${FOOTER_HEIGHT_DESKTOP}px - 44px)`,
    position: 'fixed',
    top: 45,
    left: '50%',
    transform: 'translateX(-50%)',
    right: 0,
    zIndex: 999999,
    display: 'flex',
    alignSelf: 'center',
    pointerEvents: 'none',
    [theme.breakpoints.down(1450)]: {
        maxWidth: `calc(${HT_MAX_WIDTH_CONTENT} + 32px - 60px)`,
        width: `calc(100vw - 90px)`,
        left: '48%',
        transform: 'translateX(-50%)',
        marginLeft: '60px',
    },
    [theme.breakpoints.down('md')]: {
        width: `100vw`,
        height: `calc(100vh - ${FOOTER_HEIGHT_DESKTOP}px - 40px)`,
        top: 80,
        left: 0,
        transform: 'none',
        marginLeft: 0,
    },
}));

export const CaptureModalWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    gap: 0,
    padding: 0,
    backgroundColor: theme.palette.backgrounds.bg1,
}));
export const CaptureModalTitle = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '12px',
    },
}));
export const CaptureResultModalContent = styled(Box)({});
export const CaptureModalActions = styled(Box)(({ theme }) => ({
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px',
    gap: '12px',
    borderTopWidth: '1px',
    borderColor: theme.palette.divider,
    borderStyle: 'solid',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'stretch',
    },
}));

export const DownloadIcon = styled(_DownloadIcon)({});
export const CopyIcon = styled(_CopyIcon)({});
